import React, { useEffect } from 'react';
import { Col, Container as Grid, Row } from 'react-bootstrap';
import LoginForm from './Form';
import Logo from './Logo';
import useSiteConfig from '@components/Hooks/useSiteConfig';
import Color from 'color';

const Top: React.FC = () => {

  const site_config = useSiteConfig();

  useEffect(() => {
    if (site_config) {
      document.title = site_config.title;
    }
  }, [site_config]);

  const base_color = Color(site_config?.termite.backgroundColor);

  return (
    <div
      className="logo-bg"
      style={site_config ? {
        // backgroundImage: 'url(' + site_config?.banner + ')',
        backgroundColor: site_config?.termite.backgroundColor ?? '',
        background: `linear-gradient(${['90deg',
          `${base_color.lightness(10).hex()} 0%`,
          `${base_color.hex()} 40%`,
          `${base_color.desaturate(.1).rotate(-15).hex()} 50%`,
          `${base_color.hex()} 60%`,
          `${base_color.lightness(10).hex()} 100%`
        ].join(', ')})`
      } : {}}>
      {/* {bubbles(30)} */}
      <Grid fluid>
        <Row>
          <Col md={8} >
            {/* <Col md={8} className='d-none d-md-block' > */}
            <Logo title={site_config?.title ?? ''} />
          </Col>
          <Col md={4} style={{ zIndex: 1000 }}>
            <LoginForm />
          </Col>
        </Row>
      </Grid>
    </div>
  );
}

export default Top;